import React, { useContext, useMemo } from "react";
import { Icon, Modal } from "antd";
import styles from "./index.module.scss";
import { ArrowBack, CheckRounded } from "../CustomIcons";
import CoursewareContext from "../../store";
import { CoursewareListItem } from "API/courseware";
import useRequestFn from "Utils/useRequestFn";
import { errorMessage } from "Utils/useRequest";
import { isTrue } from "Utils/filter";
import EditAksModal from "../../../../../../AskTeacher/Components/EditAksModal";
import lodash from "lodash-es";
import useModalHandler from "../../../../../../../Utils/v3/useModalHandler";

interface HeaderProps {
    onCancel?: (evt: any) => void;
}

export default function Header({ onCancel }: HeaderProps) {
    const { current, list, markDone } = useContext(CoursewareContext);

    const courseware = useMemo<CoursewareListItem | undefined>(() => {
        return list.find(item => item.id === current);
    }, [current, list]);

    const [onMark] = useRequestFn(async () => {
        if (!current) return;
        try {
            await markDone(current);
        } catch (e) {
            Modal.error(errorMessage(e));
        }
    });

    const editModal = useModalHandler({
        component: EditAksModal
    });

    function openModal() {
        const data = lodash.find(list, { id: current });
        if (data) {
            console.log(data);

            const {
                batchNo,
                courseNo,
                courseName,
                courseSeq,
                customerCode,
                sourceFileEntity
            } = data;

            editModal.open({
                batchNo: batchNo!,
                courseNo: courseNo!,
                courseName: courseName!,
                courseSeq: courseSeq!,
                customerCode: customerCode!,
                viewUrl: sourceFileEntity?.viewUrl,
                fileName: sourceFileEntity?.fileName,
                onSuccess: editModal.close
            });
        }
    }

    return (
        <div className={styles.root}>
            <button className={styles.back} onClick={onCancel}>
                <ArrowBack />
            </button>

            <h1 className={styles.title}>
                {courseware?.sourceFileEntity?.fileName}
            </h1>

            <div className={styles.buttons}>
                <button className={styles.close} onClick={onCancel}>
                    <Icon type="close" />
                </button>

                {!isTrue(courseware?.studyStatusEntity?.studyStatus) && (
                    <button className={styles.check} onClick={onMark}>
                        <CheckRounded />
                    </button>
                )}

                <button className={styles.ask} onClick={openModal}>
                    <Icon type="question-circle" />
                </button>
            </div>
            {editModal.render()}
        </div>
    );
}
